import { render, staticRenderFns } from "./TempRankingCandidateEditCard.vue?vue&type=template&id=229d6dd1&scoped=true"
import script from "./TempRankingCandidateEditCard.vue?vue&type=script&lang=js"
export * from "./TempRankingCandidateEditCard.vue?vue&type=script&lang=js"
import style0 from "./TempRankingCandidateEditCard.vue?vue&type=style&index=0&id=229d6dd1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "229d6dd1",
  null
  
)

export default component.exports